export const ensureTimeHasSeconds = (time: string): string => {
  if (!time) return time;
  const trimmed = time.trim();
  return /^\d{1,2}:\d{2}$/.test(trimmed) ? `${trimmed}:00` : trimmed;
};

/**
 * Shift length in hours from a start/end time pair ('HH:MM' or 'HH:MM:SS').
 * An end time earlier than the start time is an overnight shift and rolls into the next day.
 * Returns null when either time is missing or unparseable.
 */
export const computeShiftLengthHours = (startTime: string | null | undefined, endTime: string | null | undefined): number | null => {
  if (!startTime || !endTime) return null;

  const toMinutes = (time: string): number | null => {
    const [hours, minutes] = time.split(':').map(Number);
    return Number.isFinite(hours) && Number.isFinite(minutes) ? hours * 60 + minutes : null;
  };

  const start = toMinutes(startTime);
  const end = toMinutes(endTime);
  if (start === null || end === null) return null;

  const duration = end - start;
  return parseFloat(((duration < 0 ? duration + 24 * 60 : duration) / 60).toFixed(2));
};
